/**
 * Created by jv on 18/01/2017.
 */
const LanguageManager = require("Sources/services/languagemanager");
const utils = require("Sources/utils/utils");
const ElementCreator = require("Sources/components/element-creator");

//Styles
require("Styles/components/person-info.scss");

var template = {};

(function(Template)
{
  Template.createTitle = function(title, customClasses)
  {
    if(utils.isNotNull(customClasses) && utils.isString(customClasses))
    {
      customClasses = " " + customClasses;
    }
    else
    {
      customClasses = "";
    }

    return "<h4 class='person-info-title" + customClasses + "'>" + title + "</h4>";
  };

  Template.createInfoWrapper = function(data, options)
  {
    var infoWrapperClasses = [ "person-info-wrapper", "inner" ];

    if(utils.isNotNull(options) && utils.isArray(options.infoWrapperClasses))
    {
      infoWrapperClasses = infoWrapperClasses.concat(options.infoWrapperClasses);
    }

    var infoWrapperEl = "";
    for(var i = 0; i < data.length; i++)
    {
      var value = normalize(data[i].value);

      if(utils.isArray(value))
      {
        var tmpValue = "";
        for(var x = 0; x < value.length; x++)
        {
          if(utils.isNotNull(value[x]))
          {
            tmpValue += ElementCreator.createStringElement({ innerHTML: value[x]});
          }
        }
        value = tmpValue;
      }

      var classNames = utils.isArray(data[i].options.classNames) ? data[i].options.classNames.join(" ") : "";

      infoWrapperEl += "<div class='" + classNames + "'>";

      if(utils.isNotNull(data[i].label))
      {
        infoWrapperEl += "<div class='person-info-label'>" + LanguageManager.getValueForKey(data[i].label) + "</div>";
      }
        infoWrapperEl += "<div class='person-info-value'>" + value + "</div>";
      infoWrapperEl += "</div>";
    }

    return ElementCreator.createStringElement({
      classNames: infoWrapperClasses,
      innerHTML: infoWrapperEl
    });
  };

  function normalize(data)
  {
    return utils.isNullOrEmpty(data) ? "-" : data;
  }
}(template));

module.exports = template;



// WEBPACK FOOTER //
// ./app/js/templates/person-info.template.js